import { CommonModule } from "@angular/common";
import { HttpBackend } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

import { CacheBustMultiTranslateHttpLoader } from "@intocare/language";

import { ButtonComponent } from "./block/button.component";
import { ChipButtonComponent } from "./chip/button.component";
import { DoubleButtonComponent } from "./double/button.component";
import { IconButtonComponent } from "./icon/button.component";
import { MenuButtonComponent } from "./menu/menu-button.component";
import { OverviewButtonComponent } from "./overview-button/overview-button.component";
import { PagingButtonsComponent } from "./paging-buttons/paging-buttons.component";
import { TextButtonComponent } from "./text/button.component";
import { IconModule } from "../icon/icon.module";
import { IndicatorModule } from "../indicator/indicator.module";
import { LoadingIndicatorModule } from "../loading-indicator/loading-indicator.module";

export function translateLoaderFactory(httpBackend: HttpBackend) {
	return new CacheBustMultiTranslateHttpLoader(httpBackend, ["assets/shared/i18n/"]);
}

@NgModule({
	imports: [
		LoadingIndicatorModule,
		CommonModule,
		MatTooltipModule,
		IndicatorModule,
		MatMenuModule,
		IconModule,
		TranslateModule.forChild({
			loader: {
				provide: TranslateLoader,
				useFactory: translateLoaderFactory,
				deps: [HttpBackend],
			},
		}),
	],
	declarations: [
		ButtonComponent,
		DoubleButtonComponent,
		IconButtonComponent,
		TextButtonComponent,
		ChipButtonComponent,
		PagingButtonsComponent,
		MenuButtonComponent,
		OverviewButtonComponent,
	],
	exports: [
		ButtonComponent,
		DoubleButtonComponent,
		IconButtonComponent,
		TextButtonComponent,
		ChipButtonComponent,
		PagingButtonsComponent,
		MenuButtonComponent,
		OverviewButtonComponent,
	],
})
export class ButtonModule {}
